import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_177: DocMigration = {
  maxSchemaVersion: "0.0.177",
  description: "Lifts all ParamConfig fields to Param data type, removing Param.config",
  apply(json: any) {
    if (json.params) {
      for (const paramId in json.params) {
        const param = json.params[paramId];

        if (typeof param.config === "object" && param.config !== null) {
          json.params[paramId] = { ...param.config };
        }

        delete json.params[paramId].config;
      }
    }

    return json;
  },
};

export default migration_0_0_177;
